import { IOrderDetails } from '../Interfaces/order-details.interface';

export class OrderDetails implements IOrderDetails
{
    constructor()
    {

        this.employeeTickets = 0;
        this.nonEmployeeTickets = 0;
        this.kidsTickets = 0;
        this.employeeTicketsMax = 2;
        this.nonEmployeeTicketsMax = 0;
        this.kidsTicketsMax = 0;
        this.orderId = 0;
        this.price = 0;
        this.ticketProvider = 0;
        this.ticketType = 0;
        this.numberOfPayments = 1;
        this.numberOfPaymentsMax = 3; //will always be 3 as maximum according to Sharon.
        this.availableBenefits = undefined;
        this.totalBenefitsForEmployee = 2; 


    }
    
    employeeTickets: number;
    nonEmployeeTickets: number;
    kidsTickets: number;
    employeeTicketsMax: number;
    nonEmployeeTicketsMax: number;
    kidsTicketsMax: number;
    orderId: number;
    price: number;
    ticketProvider: number;
    ticketType: number;
    numberOfPayments:number;
    numberOfPaymentsMax:number;
    availableBenefits:number;
    totalBenefitsForEmployee:number;
}
